import Marquee from "react-fast-marquee";

const WORDS = [
  "Tarot", "Retornos de pareja", "Limpiezas y despojos", "Abre caminos",
  "Tumbabrujería", "Misas espirituales", "Vidente sin gabinete", "Clarividencia",
];

export const Ribbon = () => (
  <div data-testid="editorial-marquee" className="bg-[#C5A059] py-5 border-y border-[#05030A]/10 select-none">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8 font-serif text-2xl md:text-3xl italic text-[#1A0B2E]">
          {w}
          <span className="not-italic text-[#1A0B2E]/50">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
